export const lngList = {
    sv: "Swedish",
    en: "English",
    pt: "Portugese"
};